module.exports = __webpack_public_path__ + "static/img/23.ce8a295.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生活照/23.jpg
// module id = zgPf
// module chunks = 0